import { Box, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCircleCheck } from "@fortawesome/pro-duotone-svg-icons";
import ReactHtmlParser from "react-html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";

const ArticleAcknowledgments = (
    {
        acknowledgments
    }: {
        acknowledgments: string[]
    }
) => (
    <Box
        component="section"
        role="doc-acknowledgments"
    >
        <Typography
            component="h3"
            color="primary"
            display="flex"
            alignItems="center"
        >
            <SpanTypography
                color="primary.main"
                fontSize={'1.5rem'}
                mr={.25}
            >
                <FontAwesomeIcon
                    icon={faFileCircleCheck}
                />
            </SpanTypography>
            <SpanTypography
                fontSize={'1.5rem'}
            >
                Acknowledgments
            </SpanTypography>
        </Typography>
        <Box component="aside">
            {
                acknowledgments.map((
                    content: string,
                    index: number
                ) => (
                    <Typography
                        key={`acknowledgment-${index}`}
                    >
                        {
                            ReactHtmlParser(content)
                        }
                    </Typography>
                ))
            }
        </Box>
    </Box>
)

export default ArticleAcknowledgments;